var map = {
	"./agreement.png": 7527,
	"./bmp-icon.svg": 2157,
	"./cloud-folder.png": 8647,
	"./excel-icon.svg": 2893,
	"./jpeg-icon.svg": 4321,
	"./logo.png": 4427,
	"./panda-logo.png": 5288,
	"./pdf-icon.svg": 8302,
	"./png-icon.svg": 3441,
	"./recaptcha.png": 5570,
	"./tiff-icon.svg": 7653,
	"./welcome-image.png": 9858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;